import { Grid2 as Grid, Container, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';

import SignUpForm from '../../components/auth/SignUpForm';
import MainFooter from '../../components/layout/MainFooter';

import { useSelector } from 'react-redux';

const SignUp = () => {

  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  //Redirect
  if (isAuthenticated) {
    return <Navigate to="/home" />
  }

  return (
    <Container className='main' component="main" maxWidth="lg">
      <Grid container spacing={{ lg: 5 }}>
        <Grid className="logo" size={{ lg: 6 }}>
          <img width="400" src="/logo-os 24.svg" alt="oneService" />
          <Typography variant='h3' color="primary" mt={3}>
            "Invierte en el futuro de los servicios."
          </Typography>
        </Grid>
        <SignUpForm />
      </Grid>
      <MainFooter />
    </Container>
  );
}

export default SignUp;